import { View, Text } from "@react-pdf/renderer";
import { colors } from "../functions/Helper.js";
import tinycolor from "tinycolor2";

function PlayingTimePDF(props) {
  const backgroundColor = tinycolor(colors[props.player.colorId]);

  const left = ((props.minute.start - props.start) / props.periodLength) * 100;

  const width =
    ((props.minute.end - props.minute.start) / props.periodLength) * 100;
  return (
    <View
      style={{
        position: "absolute",
        left: left + "%",
        width: width + "%",
        height: props.barHeight + "px",
        paddingLeft: 5,
        paddingRight: 5,
        backgroundColor: backgroundColor.toString(),
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Text
        style={{
          fontWeight: "600",
          color: "white",
          fontSize: "8px",
          overflow: "hidden",
        }}
      >
        {props.player.name}
      </Text>
    </View>
  );
}

export default PlayingTimePDF;
